import type { MiddlewareHandler } from "hono";
import type { MiddlewareOptions } from "./types";
import type { HonoErrorUtility } from "./utility";

interface FactoryContext<
    TInstance extends HonoErrorUtility
> {
    instance: TInstance;
}

export type HonoMiddlewareSetup<
    TMiddlewareOptions extends MiddlewareOptions = MiddlewareOptions
> = (options: TMiddlewareOptions) => MiddlewareHandler

export const tryCatchFactory = <
    TInstance extends HonoErrorUtility,
    TFactoryContext extends FactoryContext<TInstance>,
>(factoryOptions: {
    createContext: (options: MiddlewareOptions) => TFactoryContext;
    handler: (context: TFactoryContext) => MiddlewareHandler;
}): HonoMiddlewareSetup => {
    return (options: MiddlewareOptions): MiddlewareHandler => {
        const context = factoryOptions.createContext(options);

        return factoryOptions.handler(context);
    };
};
